import Modals from "../../components/common/Modal";
import ViewBidBook from "./viewBidBook";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";
 
 

function ViewBidBookModal({ open, setOpen, modalRight }) {
  const handleBidBookClose = () => {
    dispatch(actionUrl.fetchBidBookSuccess([]));
    setOpen("");
  };
  const dispatch = useDispatch();
  return (
    <>
      <Modals
        title = "View Bid Book English"
        show={open === "viewBidBook1"}
        handleClose={() =>handleBidBookClose()}
        size="xl"
      >          
        <ViewBidBook/>
      </Modals>   
    </>
  );
}

export default ViewBidBookModal;
